var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('IHeader'),_c('main',[_c('keep-alive',{attrs:{"include":_vm.include}},[_c('router-view',{key:_vm.$route.path})],1)],1),_c('IFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }